// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zUiR8","toggle":"styles_toggle__25o2h","preview":"styles_preview__3W3T_"};